import React from "react";
import TermsConditions from "../Common/TermsConditions";
import TermsBanner from "../PageBanners/TermsBanner";
import Footer from "../Common/Footer";

class TermsConditionsPage extends React.Component {
  render() {
    return (
      <>
        <TermsBanner />
        <TermsConditions />
        <Footer />
      </>
    );
  }
}

export default TermsConditionsPage;
